import { FC, useCallback } from "react";
import { useController } from "./useController";
import { PageWrapper } from "@connectedComponents";
import { ColorsEnum, stackEnum } from "@utilities/enums";
import { CategoryCard, InventoryModal, PricingEvolutionModal, ProductCard, ProductDetailsCard, SupplyModal } from "./components";
import { Card, GenericActionsBar, Icon, Pagination } from "@components";

export const StockManageArticlesPage: FC = () => {

    const {
        isPricingEvolutionModalOpen, isViewProductDetailsModalOpen,
        filteredCategories, isInvetoryModalOpen, productsPagination,
        filteredProducts, displayCategoryProducts, selectedCategory,
        selectedProduct, isSupplyModalOpen, invertories, categories,
        handleBackClick, handleDisplayCategoryProducts,
        handleCategoryProductsBackClick, handleCreateInventoryProduct,
        setSearchProduct, setSearchCategory, handleChangePage,
        handleAddCategoryOrProduct, handleCreateSupplyProduct, handlePricingEvolution,
        handleSupplyProduct, handleSupplyModalClose, handleUpdateCategory,
        handleInventoryProduct, handleInventoryModalClose, handleViewProductDetailsModalClose,
        handleViewProductDetails, handleUpdateProduct, handlePricingEvolutionModalClose,
    } = useController();

    const cardTitle = displayCategoryProducts ? `Produits de la catégorie "${selectedCategory?.name}"` : "Gestion des catégories et produits";
    const searchPlaceholder = displayCategoryProducts ? "Rechercher un produit..." : "Rechercher une catégorie...";

    const renderCategories = useCallback(()=> {
        if(displayCategoryProducts) return;

        return (
            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" >
                {
                    filteredCategories.map((category, i) => (
                        <CategoryCard
                            key={i}
                            category={category}
                            onEdit={handleUpdateCategory}
                            onViewProducts={()=> handleDisplayCategoryProducts(category)}
                        />
                    ))
                }
            </div>
        )
    }, [
        displayCategoryProducts, filteredCategories,
        handleDisplayCategoryProducts, handleUpdateCategory,
    ]);

    const renderProducts = useCallback(()=> {
        if(!displayCategoryProducts) return;

        return (
            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" >
                {
                    filteredProducts.map((product, i) => (
                        <ProductCard 
                            key={i}
                            categories={categories}
                            product={product}
                            onViewDetails={()=> handleViewProductDetails(product)}
                            onEdit={handleUpdateProduct}
                            onInventory={()=> handleInventoryProduct(product)}
                            onSupply={()=> handleSupplyProduct(product)}
                            onPricingEvolution={()=> handlePricingEvolution(product)}
                            onPromotion={()=> {}}
                        />
                    ))
                }

                {
                    productsPagination && (
                        <Pagination
                            currentPage={productsPagination.currentPage}
                            totalPages={productsPagination.totalPages}
                            onPageChange={handleChangePage}
                        />
                    )
                }
            </div>
        )
    }, [
        productsPagination, displayCategoryProducts, filteredProducts,
        categories, handleSupplyProduct, handleUpdateProduct,
        handleInventoryProduct, handleChangePage, 
        handleViewProductDetails, handlePricingEvolution,
    ]);

    return (
        <PageWrapper
            activeStack={stackEnum.stocksStack}
            handleGoBack={displayCategoryProducts ? handleCategoryProductsBackClick : handleBackClick}
        >
            <Card
                title={cardTitle}
                customClassName="bg-none md:bg-white"
                actions={
                    <GenericActionsBar
                        searchPlaceholder={searchPlaceholder}
                        handleSearch={displayCategoryProducts ? setSearchProduct : setSearchCategory}
                        customActions={[
                            <button
                                className="btn btn-ghost btn-circle"
                                onClick={handleAddCategoryOrProduct}
                            >
                                <Icon iconName="Plus" size={20} color={ColorsEnum.SECONDARY} />
                            </button> 
                        ]}
                    />
                }
            >
                {renderCategories()}

                {renderProducts()}
            </Card>

            <SupplyModal 
                isOpen={isSupplyModalOpen}
                product={selectedProduct}
                onClose={handleSupplyModalClose}
                onSupply={handleCreateSupplyProduct}
            />

            <InventoryModal 
                isOpen={isInvetoryModalOpen}
                product={selectedProduct}
                invertories={invertories}
                onClose={handleInventoryModalClose}
                onAddNewInventory={handleCreateInventoryProduct}
            />

            <PricingEvolutionModal 
                isOpen={isPricingEvolutionModalOpen}
                product={selectedProduct}
                onClose={handlePricingEvolutionModalClose}
            />

            <ProductDetailsCard 
                product={selectedProduct}
                isOpen={isViewProductDetailsModalOpen}
                onClose={handleViewProductDetailsModalClose}
            />
        </PageWrapper>
    );

}
